module.exports = __webpack_public_path__ + "static/img/mailnoData.e40af010.png";